(function() {
  function initEmbroideryConfigurator(configurator) {
    if (configurator.dataset.initialized === 'true') {
      return;
    }

    var section = configurator.closest('.product-section');
    // Quick view rewrites element ids with a `-modal` suffix, so resolve the
    // form within this configurator's own section first, then fall back to ids.
    var form = section ? section.querySelector('form.product-single__form') : null;
    if (!form) {
      form = document.getElementById(configurator.dataset.formId) || document.getElementById(configurator.dataset.formId + '-modal');
    }
    var body = configurator.querySelector('[data-embroidery-body]');
    var input = configurator.querySelector('[data-embroidery-input]');
    var limitText = configurator.querySelector('[data-embroidery-limit]');
    var error = configurator.querySelector('[data-embroidery-error]');
    var price = configurator.querySelector('[data-embroidery-price]');
    var preview = configurator.querySelector('[data-embroidery-preview]');
    var propertyInputs = {
      embroidery: configurator.querySelector('[data-embroidery-property]'),
      initials: configurator.querySelector('[data-embroidery-initials-property]'),
      flags: configurator.querySelector('[data-embroidery-flags-property]')
    };

    if (!form || !section || !input || !preview) {
      return;
    }

    configurator.dataset.initialized = 'true';

    function maxInitials() {
      return Number(configurator.dataset.maxInitials || 3);
    }

    function flagUrl(letter) {
      return configurator.dataset.flagUrlTemplate.replace('LETTER', letter.toLowerCase());
    }

    function cleanInitials(value) {
      return value.toUpperCase().replace(/[^A-Z]/g, '').slice(0, maxInitials());
    }

    function renderFlags(target, initials) {
      if (!target) {
        return;
      }

      target.innerHTML = '';

      initials.split('').forEach(function(letter) {
        var img = document.createElement('img');
        img.src = flagUrl(letter);
        img.alt = letter + ' signal flag';
        target.appendChild(img);
      });

      if ('hidden' in target) {
        target.hidden = initials.length === 0;
      }
    }

    function setError(message) {
      if (!error) {
        return;
      }

      error.textContent = message || '';
      error.hidden = !message;
      input.setAttribute('aria-invalid', message ? 'true' : 'false');
    }

    function syncProperties(initials) {
      var enabled = initials.length > 0;
      propertyInputs.embroidery.disabled = !enabled;
      propertyInputs.initials.disabled = !enabled;
      propertyInputs.flags.disabled = !enabled;
      propertyInputs.initials.value = initials;
      propertyInputs.flags.value = initials.split('').join(', ');
    }

    function update() {
      var max = maxInitials();
      var initials = cleanInitials(input.value);
      input.value = initials;
      input.maxLength = max;

      if (limitText) {
        limitText.textContent = 'Max ' + max + ' letter' + (max === 1 ? '' : 's');
      }

      if (price) {
        price.textContent = configurator.getAttribute('data-addon-price-' + Math.max(initials.length, 1)) || configurator.getAttribute('data-addon-price-1');
      }

      body.hidden = false;
      renderFlags(preview, initials);
      syncProperties(initials);
      setError('');
    }

    function addEmbroideryItems(event) {
      event.preventDefault();
      event.stopImmediatePropagation();

      var initials = cleanInitials(input.value);
      var addonId = configurator.getAttribute('data-addon-' + initials.length);
      var submitButton = form.querySelector('[data-add-to-cart]');

      if (!initials) {
        setError('Please enter your embroidery letters before adding to cart.');
        input.focus();
        return;
      }

      if (!addonId) {
        setError('Embroidery pricing is not available for this number of letters.');
        input.focus();
        return;
      }

      syncProperties(initials);

      var formData = new FormData(form);
      var bagVariantId = formData.get('id');
      var quantity = Number(formData.get('quantity') || 1);
      var properties = {};
      var embroideryGroupId = 'embroidery-' + Date.now() + '-' + Math.random().toString(36).slice(2, 10);

      formData.forEach(function(value, key) {
        var match = key.match(/^properties\[(.+)\]$/);
        if (match && value) {
          properties[match[1]] = value;
        }
      });

      properties.Embroidery = 'Yes';
      properties.Initials = initials;
      properties.Flags = initials.split('').join(', ');
      properties['_Embroidery group'] = embroideryGroupId;

      if (submitButton) {
        submitButton.classList.add('btn--loading');
      }

      fetch((window.theme && theme.routes && theme.routes.cartAdd) || '/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Accept': 'application/json',
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          items: [
            {
              id: Number(bagVariantId),
              quantity: quantity,
              properties: properties
            },
            {
              id: Number(addonId),
              quantity: quantity,
              properties: {
                'For': configurator.dataset.productTitle,
                'Initials': initials,
                '_Embroidery addon': 'Yes',
                '_Embroidery group': embroideryGroupId,
                '_Linked bag variant': String(bagVariantId)
              }
            }
          ]
        })
      })
      .then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok || data.status === 422) {
            throw data;
          }
          return data;
        });
      })
      .then(function(data) {
        form.dispatchEvent(new CustomEvent('ajaxProduct:added', {
          bubbles: true,
          detail: {
            product: data.items ? data.items[0] : data,
            addToCartBtn: submitButton
          }
        }));
      })
      .catch(function(data) {
        setError(data && (data.description || data.message) ? (data.description || data.message) : 'Embroidery could not be added. Please try again.');
        form.dispatchEvent(new CustomEvent('ajaxProduct:error', {
          bubbles: true,
          detail: {
            errorMessage: data && (data.description || data.message) ? (data.description || data.message) : 'Embroidery could not be added. Please try again.'
          }
        }));
      })
      .finally(function() {
        if (submitButton) {
          submitButton.classList.remove('btn--loading');
        }
      });
    }

    input.addEventListener('input', update);
    form.addEventListener('submit', addEmbroideryItems, true);
    update();
  }

  function initAll() {
    document.querySelectorAll('[data-embroidery-configurator]').forEach(initEmbroideryConfigurator);
  }

  // Quick view trial rollout: only Signal Flag Tote products get the
  // configurator wired up inside quick-shop modals.
  function initQuickView() {
    document.querySelectorAll('[data-embroidery-configurator]').forEach(function(configurator) {
      if (configurator.dataset.initialized === 'true') {
        return;
      }
      var title = (configurator.dataset.productTitle || '').toLowerCase();
      if (title.indexOf('signal flag tote') === -1) {
        return;
      }
      initEmbroideryConfigurator(configurator);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
  document.addEventListener('quickview:loaded', initQuickView);
})();
